"use client";

import {
    Controller,
    Control,
    FieldError,
    FieldValues,
    Path,
    PathValue,
} from "react-hook-form";
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { useEffect, useState } from "react";
import { IoAlertCircleOutline } from "react-icons/io5";

interface SelectFieldProps<TFormData extends FieldValues> {
    name: Path<TFormData>;
    control: Control<TFormData>;
    error?: FieldError;
    label: string;
    options: { value: string }[];
    defaultValue?: string;
    btnStyles?: string;
    labelStyles?: string;
}

const CustomSelectOption = <TFormData extends FieldValues>({
    name,
    control,
    error,
    label,
    options,
    defaultValue,
    btnStyles,
    labelStyles
}: SelectFieldProps<TFormData>) => {
    const [selected, setSelected] = useState<string>(defaultValue || "");

    const handleSelectChange = (value: string) => {
        setSelected(value);
    };

    useEffect(() => {
        if (defaultValue) {
            setSelected(defaultValue);
        }
    }, [defaultValue]);

    return (
        <div>
            <label
                className={`${labelStyles ? labelStyles : ""} text-[11px] md:text-xs text-lime-800`}
                htmlFor={name}
            >
                {label}
            </label>
            <Controller
                name={name}
                control={control}
                defaultValue={
                    defaultValue as PathValue<TFormData, Path<TFormData>>
                }
                render={({ field }) => (
                    <Select
                        dir="rtl"
                        onValueChange={(value) => {
                            field.onChange(value);
                            handleSelectChange(value);
                        }}
                        value={selected}
                    >
                        <SelectTrigger className={`${btnStyles ? btnStyles : ''} w-full py-[1px] h-[32px] px-2  border border-gray-200`}>
                            <SelectValue placeholder="انتخاب کنید" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectGroup>
                                {options.map((option) => (
                                    <SelectItem
                                        value={option.value}
                                        key={option.value}
                                    >
                                        {option.value}
                                    </SelectItem>
                                ))}
                            </SelectGroup>
                        </SelectContent>
                        {error && (
                            <span className="text-sm text-red-400">
                                <IoAlertCircleOutline className="inline mr-1" />{" "}
                                {error.message}
                            </span>
                        )}
                    </Select>
                )}
            />
        </div>
    );
};

export default CustomSelectOption;
